"use client";

import { useEffect, useState } from "react";

import { Database } from "../../supabase.types";
import { Session } from "@supabase/supabase-js";
import { createClientComponentClient } from "../../supabase/client";
import { getSession } from "../../supabase/supabase";

/**
 * useSession Usage:
 * Gets the current session from Supabase and returns it.
 *
 * @returns
 * - undefined if the session is still loading
 * - null if the user is not logged in
 * - a Supabase Session object if the user is logged in
 */
export default function useSession() {
  const [session, setSession] = useState<Session | null | undefined>(undefined);
  const supabase = createClientComponentClient<Database>();

  useEffect(() => {
    // retrieve the session and initialize the state
    getSession(supabase).then((session) => {
      setSession(session);
    });

    // subscribe to auth state changes
    const { data } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_OUT") {
        setSession(null);
      } else if (session) {
        setSession(session);
      }
    });

    // call unsubscribe to remove the event listener
    return () => data.subscription.unsubscribe();
  }, [supabase]);

  return session;
}
